module.exports = __webpack_public_path__ + "static/img/3_1_1.b5051f3f.jpg";